import React, { useState } from 'react';

import classes from './LoadingLayer.module.css';
import LoadingBlock from './LoadingBlock';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

const LoadingLayer = ({visible, transitionEnd}) => {

  function handleTransitionEnd() {
    transitionEnd?.()
  }
  return (
    <div className={clsx(classes.LoadingLayer, visible && classes.visible)} onTransitionEnd={handleTransitionEnd}>
      <LoadingBlock/>
    </div>
  );
};

export default observer(LoadingLayer);
